import { z } from "zod";

export interface EventStatsItem {
  type_id: number;
  sort_index: number;
}

export const statsFiltersSchema = z.object({
  event_ids: z
    .string()
    .optional()
    .transform((val) =>
      val
        ? val
            .split(",")
            .map(Number)
            .map(
              (type_id): EventStatsItem => ({
                type_id,
                sort_index: 0, // или другое значение по умолчанию
              })
            )
        : undefined
    )
    .refine((arr) => arr?.every((item) => Number.isInteger(item.type_id)), {
      message: "event_ids должны содержать только числа",
    }),
  user_ids: z
    .string()
    .optional()
    .transform((val) => (val ? val.split(",").map(Number) : undefined))
    .refine((arr) => arr?.every((id) => Number.isInteger(id)), {
      message: "user_ids должны содержать только числа",
    }),
  group_ids: z
    .string()
    .optional()
    .transform((val) => (val ? val.split(",").map(Number) : undefined))
    .refine((arr) => arr?.every((id) => Number.isInteger(id)), {
      message: "group_ids должны содержать только числа",
    }),
  source_ids: z
    .string()
    .optional()
    .transform((val) => (val ? val.split(",").map(Number) : undefined))
    .refine((arr) => arr?.every((id) => Number.isInteger(id)), {
      message: "source_ids должны содержать только числа",
    }),
  date_start: z.string().optional(),
  date_end: z.string().optional(),
});

export type StatsFilters = z.infer<typeof statsFiltersSchema>;

export const saleFunnelTemplate: EventStatsItem[] = [
  {
    type_id: 1, // Регистрация
    sort_index: 10,
  },
  /* {
      type_id: 2, // Звонок
      sort_index: 2
  }, */
  {
    type_id: 3, // Консультация
    sort_index: 30,
  },
  {
    type_id: 14, // Вопрос о счете
    sort_index: 40,
  },
  {
    type_id: 16, // Открытие счёта
    sort_index: 50,
  },
  {
    type_id: 17, // Последующее пополнение
    sort_index: 60,
  },
];

export const practiceFunnelTemplate: EventStatsItem[] = [
  {
    type_id: 4, // Практика 1
    sort_index: 10,
  },
  {
    type_id: 5, // Практика 2
    sort_index: 20,
  },
  {
    type_id: 6, // Практика 3
    sort_index: 30,
  },
  {
    type_id: 7, // Практика 4
    sort_index: 40,
  },
  {
    type_id: 8, // Практика 5
    sort_index: 50,
  },
  {
    type_id: 9, // Практика 6
    sort_index: 60,
  },
  {
    type_id: 10, // Практика 7
    sort_index: 70,
  },
  {
    type_id: 11, // Практика 8
    sort_index: 80,
  },
  {
    type_id: 12, // Практика 9
    sort_index: 90,
  },
  {
    type_id: 13, // Практика 10
    sort_index: 100,
  },
];

export const hireFunnelTemplate: EventStatsItem[] = [
  {
    type_id: 1,
    sort_index: 10,
  },
  {
    type_id: 18,
    sort_index: 20,
  },
  {
    type_id: 20,
    sort_index: 30,
  },
  {
    type_id: 21,
    sort_index: 40,
  },
  {
    type_id: 22,
    sort_index: 50,
  },
  {
    type_id: 23,
    sort_index: 60,
  },
];
